import React from "react";
import { Grid } from "components/Containers";
import PropTypes from "prop-types";
import { ProfileVideoInterviewsList } from "components/Profile";
import ApplicationQuestionnaireResponses from "./ApplicationQuestionnaireResponses";
import { useMissionRoleApplicant, useAssessment } from "hooks";
import { MessagesError } from "components/Messages";
import ApplicantSectionWithTitle from "./ApplicantSectionWithTitle";

/**
 * ApplicantCandidateInsights
 *
 * @param {Object} application
 * @param {String} profileId
 */
const ApplicantCandidateInsights = ({ profileId, application }) => {
  const { loading, data, error } = useMissionRoleApplicant({ id: application?.id });

  const { data: assessment, loading: assessmentLoading } = useAssessment({
    id: data?.missionRole?.assessmentId,
    resourceId: data?.profile?.id,
  });

  if (error) return <MessagesError />;

  return (
    <Grid gap="1.5rem">
      <Grid.col start={1} end={13}>
        <ApplicantSectionWithTitle titleMsgId="Missions.Applicants.ApplicantCandidateInsights.QuestionaireTitle">
          <ApplicationQuestionnaireResponses
            loading={loading || assessmentLoading}
            data={data}
            assessment={assessment}
          />
        </ApplicantSectionWithTitle>
      </Grid.col>

      <Grid.col start={1} end={13}>
        <ApplicantSectionWithTitle titleMsgId="Missions.Applicants.ApplicantCandidateInsights.VideoInterviewTitle">
          <ProfileVideoInterviewsList profileId={profileId} />
        </ApplicantSectionWithTitle>
      </Grid.col>
    </Grid>
  );
};

ApplicantCandidateInsights.propTypes = {
  profileId: PropTypes.string.isRequired,
  application: PropTypes.object.isRequired,
};

export default ApplicantCandidateInsights;
